// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { combineReducers } from 'redux';

// Import your reducers
import authReducer from './authSlice';
import cartReducer from "./cartSlice";
import userReducer from "./userSlice";
import providerProfileReducer from "./providerProfileSlice";
import eventServiceReducer from './eventServiceSlice';
import cartbodySlice from './cartbodydataslice';
import eventcart from './eventsliceforcart';
import ordernavigation from "./orderNavigationSlice";
import serviceBookingReducer from './serviceBookingSlice';
import checkoutSliceReducer from './checkoutSlice'

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['serviceBooking', 'eventService'] // Only persist these reducers
};

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  user: userReducer,
  providerProfile: providerProfileReducer,
  eventService: eventServiceReducer,
  cartbodyslice: cartbodySlice,
  eventcartdata: eventcart,
  ordernavigation: ordernavigation,
  serviceBooking: serviceBookingReducer,
  checkout:checkoutSliceReducer
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);